import React from "react";
import { classNames } from "Utils/utils";

const PaTabs = ({
  tabs = [],
  activeTab,
  onChange,
  className,
  panelClassName,
}) => {
  const active = tabs.find((tab) => tab.id === activeTab) || tabs[0];

  return (
    <div className={className}>
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex gap-6 overflow-x-auto" aria-label="Tabs">
          {tabs.map((tab) => {
            const isActive = tab.id === active?.id;

            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => onChange(tab.id)}
                className={classNames(
                  "inline-flex items-center whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
                  isActive
                    ? "border-indigo-500 text-indigo-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                )}
                aria-current={isActive ? "page" : undefined}
              >
                {tab.label}
                {tab.badge != null && tab.badge > 0 ? (
                  <span
                    className={classNames(
                      "ml-2 inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold leading-none",
                      isActive ? "bg-indigo-100 text-indigo-700" : "bg-amber-100 text-amber-800"
                    )}
                  >
                    {tab.badge}
                  </span>
                ) : null}
              </button>
            );
          })}
        </nav>
      </div>
      {active?.content ? (
        <div className={classNames("pt-6", panelClassName)}>{active.content}</div>
      ) : null}
    </div>
  );
};

export default PaTabs;
